import { Box, Button, Paper, Typography, styled, Tabs, Tab } from '@mui/material';

export const UploadContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  backgroundColor: '#FFFFFF',
  borderRadius: '4px',
  boxShadow: 'none',
  marginBottom: theme.spacing(3),
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '32px',
  marginBottom: theme.spacing(3),
  color: '#333333',
  alignSelf: 'flex-start',
}));

export const UploadButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#00B6BA',
  color: '#FFFFFF',
  borderRadius: '4px',
  fontWeight: 600,
  padding: '8px 16px',
  minWidth: 'fit-content',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: '#009B9F',
  },
  '&:disabled': {
    backgroundColor: '#E0E0E0',
    color: '#9E9E9E',
    opacity: 0.7,
    cursor: 'not-allowed',
    boxShadow: 'none',
    pointerEvents: 'auto',
    '&:hover': {
      backgroundColor: '#E0E0E0',
    }
  },
}));

export const ChooseFileButton = styled(Button)(({ theme }) => ({
  borderColor: '#00B6BA',
  color: '#00B6BA',
  padding: '8px 16px',
  minWidth: 'fit-content',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    borderColor: '#009B9F',
    backgroundColor: 'rgba(0, 182, 186, 0.04)',
  },
  '&:disabled': {
    borderColor: '#E0E0E0',
    color: '#9E9E9E',
  },
}));

export const MainContent = styled(Box)<{ sidebarOpen?: boolean }>(({ theme, sidebarOpen }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: 'margin-left 0.3s ease',
  backgroundColor: '#E7EFF5',
  minHeight: 'calc(100vh - 72px)',
  height: '100%',
}));

export const TableContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#FFFFFF',
  borderRadius: '4px',
  boxShadow: 'none',
  marginBottom: theme.spacing(3),
}));

export const TableTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '18px',
  marginBottom: theme.spacing(2),
  color: '#333333',
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: '1px solid #E0E0E0',
  marginBottom: theme.spacing(3),
  '& .MuiTabs-indicator': {
    backgroundColor: '#00B6BA',
  },
}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '14px',
  color: '#666666',
  '&.Mui-selected': {
    color: '#00B6BA',
  },
  '&:hover': {
    color: '#009B9F',
  },
}));

export const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
  flexWrap: 'wrap',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}));

export const SectionDivider = styled(Box)(({ theme }) => ({
  height: '1px',
  backgroundColor: '#E0E0E0',
  width: '100%',
  margin: theme.spacing(3, 0),
}));

export const UploadSection = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const TablesSection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const ErrorContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: '#ffebee',
  border: '1px solid #e57373',
  borderRadius: '4px',
  marginTop: theme.spacing(2),
}));

export const SuccessContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: '#e8f5e8',
  border: '1px solid #4caf50',
  borderRadius: '4px',
  marginTop: theme.spacing(2),
})); 